/**
 * This is default accordion class with a11y functions
 * Please fee free to update this class directly or inherit from it
 */
export default class Accordion {
  constructor(elem, APP) {
    this.elem = elem;
    this.triggers = this.elem.querySelectorAll(".js-accordion-trigger");
    this.panels = this.elem.querySelectorAll(".js-accordion-panel");

    this.flags = {
      disableClickOutside: false,
    }
  }

  /**
   * a11y - tabindex
   */
  updateChildElemsTabIndex() {
    this.panels.forEach((panel) => {
      const focusElementTypes = ["a", "button", "iframe"];
      const focusElements = panel.querySelectorAll(focusElementTypes.join(", "));

      if (panel.classList.contains("expanded")) {
        // Disable the tab index to prevent it from receiving focus by keyboard controls.
        focusElements.forEach((elem) => {
          elem.removeAttribute("tabindex");
        });
      } else {
        // Enable the tab index
        focusElements.forEach((elem) => {
          elem.setAttribute("tabindex", -1);
        });
      }
    });
  }

  /**
   * Clicking an accordion trigger opens/collapses the corresponding panel.
   * @param {number} index
   */
  togglePanel(index) {
    const trigger = this.triggers[index];
    const panel = this.panels[index];
    const panelHeight = `${
      panel.querySelector(".js-accordion-content").offsetHeight
    }px`;
    const targetState = indexPanel.classList.contains("expanded");

    panel.style.height = targetState ? panelHeight : 0;
    panel.setAttribute("aria-hidden", !targetState);
    trigger.setAttribute("aria-expanded", targetState);

    this.updateChildElemsTabIndex();
  }

  /**
   * Opens the selected accordion panel and closes others, or closes all panels if index is null or undefined.
   * @param {number|null|undefined} index - Index of the panel to open, or null/undefined to close all panels.
   */
  toggleAllPanels(index) {

    let targetState, indexPanel, panelHeight; 
     if (index === null || index === undefined) {
        targetState = false; // Collapse all panels
     }else{
        indexPanel = this.panels[index];
        panelHeight = `${
          indexPanel.querySelector(".js-accordion-content").offsetHeight
        }px`;
      targetState = indexPanel.classList.contains("expanded");
    }
    this.panels.forEach((panel, i) => {
      if (i === index && !targetState) {
        panel.style.height = panelHeight;
        panel.setAttribute("aria-hidden", false);
        panel.classList.add("expanded");
        this.triggers[i].setAttribute("aria-expanded", true);
      } else {
        panel.style.height = 0;
        panel.setAttribute("aria-hidden", true);
        panel.classList.remove("expanded");
        this.triggers[i].setAttribute("aria-expanded", false);
      }
    });

    this.updateChildElemsTabIndex();
  }

  /**
   * Set the accordion trigger click handler
   */
  setTriggerHandler() {
    this.triggers.forEach((t, i) => {
      t.addEventListener("click", () => {
        this.toggleAllPanels(i);
      });
    });
  }

  /**
   * Resizing the window updates the opened accordion panel height.
   */
  resizePanel() {
    this.panels.forEach((elem) => {
      const targetHeight = elem.querySelector("div").offsetHeight + "px";
      elem.style.height = elem.classList.contains("expanded")
        ? targetHeight
        : "0";
    });
  }
  
  /**
   * Detects click outside the accordion and closes open item
   * @param {MouseEvent} event
   */
  handleClickOutside(event) {
    // Only close if the click target is not a trigger, inside a trigger, or inside a panel
    const isTrigger = Array.from(this.triggers).some(trigger => trigger.contains(event.target));
    const isPanel = Array.from(this.panels).some(panel => panel.contains(event.target));
    if (!isTrigger && !isPanel) {
      this.toggleAllPanels();
    }
  }


  
  init() {
    this.setTriggerHandler();

    // open first accordion on the page load
    if (this.elem.dataset.openFirst) {
      this.toggleAllPanels(0);
    } else {
      this.updateChildElemsTabIndex();
    }

    window.addEventListener("resize", () => {
      this.resizePanel();
    });

    if (!this.flags.disableClickOutside) {
      document.addEventListener("click", this.handleClickOutside.bind(this));
    }
  }

}
